import './styles/main.css'

import React from 'react'
import ReactDOM from 'react-dom/client'
import z from 'zod'

import { EntryApp } from './entry-app'

z.config(z.locales.id())

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('No root element found')
}

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <EntryApp />
    </React.StrictMode>
  )
}
